<div class="container">
    <div class="selected_container">
        <div class="deliveryPointLabel">
            <span class="pickup_label" *ngIf="deliveryPoint.label">{{deliveryPoint.label}}</span>
            <div class="typePointContainer" *ngIf="isMobileScreen">
                <div class="typePoint">{{typePoint}}</div>
                <div class="button" *ngIf="typePoint==='Voisin-relais'" (click)="redirect('https://www.mypickme.com/comment-ca-marche')">
                  <a class="button_action">{{labelButtonPickme}}</a>
                </div>
            </div>
            <span class="address" *ngIf="deliveryPoint.line2 || deliveryPoint.line3">{{deliveryPoint.line2 | lowercase}}
                {{deliveryPoint.line3 | lowercase}}</span>
            <span class="address" *ngIf="deliveryPoint.zipCode ||deliveryPoint.city">{{deliveryPoint.zipCode | lowercase}} -
                {{deliveryPoint.city | uppercase}}</span>
            <div class="picto_container" *ngIf="!isMobileScreen">
                <img class="picto" *ngIf="deliveryPoint.parking" src="assets/images/parking.svg" alt="parking">
                <img class="picto" *ngIf="deliveryPoint.mobility" src="assets/images/wheelchair.svg"
                    alt="mobility access">
            </div>
            <div class="typePointContainer">
              <div class="typePoint" *ngIf="!isMobileScreen"> {{typePoint}}</div>
              <div class="button" *ngIf="!isMobileScreen && typePoint==='Voisin-relais'" (click)="redirect('https://www.mypickme.com/comment-ca-marche')">
                <a class="button_action">{{labelButtonPickme}}</a>
              </div>
            </div>
        </div>
        <!-- BLOC DESKTOP -->
        <div class="deliveryPointOpenHours" *ngIf="!isMobileScreen">
            <app-opening-hours [refDeliveryinformation]="refDeliveryinformation"></app-opening-hours>
        </div>
        <div class="selected_button_container">
            <!-- Deux div pour gérer si un point n'est pas encore sélectionné -->
            <ng-template [ngIf]="!isMobileScreen">
                <div *ngIf="chosenDeliveryPoint" class="selected_button" (click)="choosePickup(deliveryPoint)"
                    [ngStyle]="{'background-color' : chosenDeliveryPoint.order === deliveryPoint.order? '#EE7203': 'white', 'border' :  chosenDeliveryPoint.order === deliveryPoint.order? 'none' : 'black 0.5px solid' }">
                    {{"button.select" | translate}}
                </div>
                <div *ngIf="!chosenDeliveryPoint" class="selected_button" (click)="choosePickup(deliveryPoint)">
                    {{"button.select" | translate}}
                </div>
            </ng-template>
            <ng-template [ngIf]="isMobileScreen">
                <mat-radio-button [checked]="chosenDeliveryPoint===deliveryPoint"></mat-radio-button>
            </ng-template>
        </div>
    </div>
    <!-- BLOC MOBILE -->
    <!-- Pictos Mobility, Parking + button toggle openingHours-->
    <div class=toggle-container *ngIf="isMobileScreen">
        <div class="picto_container">
            <img class="picto" *ngIf="deliveryPoint.parking" src="assets/images/parking.svg" alt="parking">
            <img class="picto" *ngIf="deliveryPoint.mobility" src="assets/images/wheelchair.svg" alt="mobility access">
        </div>
        <div class="toggle-label" (click)="toggleOpeningHours()"> {{"button.more_details" | translate}}
            <img *ngIf="isMobileScreen" class="info_button" src="assets/images/arrow-down.svg"
                alt="pictogramme information" [ngStyle]="!isCollapsed ? {'transform': 'scaleY(-1)'} : ''">
        </div>
    </div>
    <!-- openingHours block -->
    <div class="deliveryPointOpenHours" *ngIf="!isCollapsed && isMobileScreen">
      <app-opening-hours [refDeliveryinformation]="refDeliveryinformation"></app-opening-hours>
    </div>
</div>
